import directus from '@/plugins/directusSdk'
import errorDirectus from '@/lib/Error/directus'

export default {
  async removeUsers ({ dispatch }) {
    try {
      const users = await directus.getUsers({
        filter: {
          id: {
            neq: 1
          }
        }
      })
      const userIds = users.data.map(item => item.id)
      if (userIds.length !== 0) await directus.deleteItems('directus_users', userIds)
    } catch (err) {
      errorDirectus(err, dispatch)
    }
  }
}
